import { Textarea } from "@/src/components/ui/textarea";
import { useToast } from "@/src/components/ui/use-toast";
import { useFetch } from "@/src/lib/useFetch";
import { zodResolver } from "@hookform/resolvers/zod";
import { Button } from "@/src/components/ui/button";
import { useForm, FormProvider } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { PostTopLevelRegionValues, PostTopLevelRegionSchema } from "../schemas";
import { Label } from "@/src/components/ui/label";
import { FormErrors } from "../components/FormErrors";

export function AddTopLevelRegion() {
  const { fetch } = useFetch();
  const { toast } = useToast();
  const navigate = useNavigate();

  const onSubmit = async (data: PostTopLevelRegionValues) => {
    try {
      const response = await fetch<{ data: { id: string } }>("/api/locations/top-level-regions", "POST", data);
      toast({ title: "Success", description: "Top-level region added successfully" });
      navigate(`/locations/top-level-regions/${response.data.id}`);
    } catch (error) {
      toast({ title: "Error", description: "Failed to add top-level region", variant: "destructive" });
    }
  };

  return (
    <div className="rounded-2xl shadow-md bg-white p-4">
      <h2 className="text-lg font-semibold">Add Top-Level Region</h2>
      <EditTopLevelRegionForm onSubmit={onSubmit} />
    </div>
  );
}

export function EditTopLevelRegionForm({ onSubmit }: { onSubmit: (data: PostTopLevelRegionValues) => void }) {
  const form = useForm<PostTopLevelRegionValues>({
    resolver: zodResolver(PostTopLevelRegionSchema),
  });

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = form;

  return (
    <FormProvider {...form}>
      <form onSubmit={handleSubmit(onSubmit)} className="space-y-4 p-4">
        <div>
          <Label>Names</Label>
          <Textarea {...register("names")} placeholder="Enter names, one per line" />
        </div>

        <FormErrors errors={errors} />

        <Button type="submit">Save</Button>
      </form>
    </FormProvider>
  );
}
